import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { History } from '@df/session/api/history/history';
import { HistoryOrder } from '@df/session/api/history/history-order';
import { ProductResource } from '@df/catalog/product/product.resource';

@Injectable({
    providedIn: 'root'
})
export class CustomerHistoryOrderResolver implements Resolve<HistoryOrder | undefined> {
    constructor(
        private history: History,
        private productResource: ProductResource
    ) {}

    resolve(route: ActivatedRouteSnapshot): Promise<HistoryOrder | undefined> {
        return new Promise((resolve, reject) => {
            this.history
                .load()
                .then(() => {
                    const id = parseInt(route.paramMap.get('id') as string, 10);
                    const order = id ? (this.history.orders || []).find(i => i.data?.id === id) : undefined;
                    const productsIds = order?.items?.map(i => i.data?.product_id);

                    const resolveOrder = () => {
                        resolve(order);
                    };

                    if (productsIds?.length) {
                        this.productResource.loadAllIds(productsIds, 3).finally(resolveOrder);
                    } else {
                        resolveOrder();
                    }
                })
                .catch(reject);
        });
    }
}
